export default "__VITE_ASSET__C4sVvU_v__"